import ApiEndpointConstants from "../constans/ApiEndpointConstants";
import api from "./API";

export const delete_incoming_account = (id) => {
  // 后端使用 DELETE，参数从 Body JSON 传递，需要通过 axios config 的 data 字段携带
  return api.delete(`${ApiEndpointConstants.DELETE_MERCHANT_ACCOUNT}`, {
    data: { id },
  });
};
